export type EstrategiaIdAgendamento =
  | { tipo: "campo"; campo: string }
  | { tipo: "template"; campos: string[] };

function campoValido(valor: unknown): valor is string {
  return typeof valor === "string" && valor.trim().length > 0;
}

export function validarEstrategiaIdAgendamento(
  valor: unknown,
): EstrategiaIdAgendamento {
  if (!valor || typeof valor !== "object") {
    throw new Error("Estratégia de identificação inválida.");
  }

  const estrategia = valor as {
    tipo?: unknown;
    campo?: unknown;
    campos?: unknown;
  };

  if (estrategia.tipo === "campo" && campoValido(estrategia.campo)) {
    return { tipo: "campo", campo: estrategia.campo.trim() };
  }

  if (
    estrategia.tipo === "template" &&
    Array.isArray(estrategia.campos) &&
    estrategia.campos.length > 0 &&
    estrategia.campos.every(campoValido)
  ) {
    const campos = estrategia.campos.map((campo) => campo.trim());
    if (new Set(campos).size === campos.length) {
      return { tipo: "template", campos };
    }
  }

  throw new Error("Estratégia de identificação inválida.");
}

export function camposDaEstrategia(
  estrategia: EstrategiaIdAgendamento,
): string[] {
  return estrategia.tipo === "campo"
    ? [estrategia.campo]
    : estrategia.campos;
}

export function labelDoCampoIdAgendamento(campo: string): string {
  const [primeiraLetra = "", ...restante] = Array.from(campo);
  return `${primeiraLetra.toLocaleUpperCase()}${restante.join("")}`;
}

export function todosCamposIdAgendamentoPreenchidos(
  estrategia: EstrategiaIdAgendamento,
  valores: Record<string, string>,
): boolean {
  return camposDaEstrategia(estrategia).every((campo) =>
    (valores[campo] ?? "").trim().length > 0,
  );
}

export function montarIdentificadorAgendamento(
  estrategia: EstrategiaIdAgendamento,
  valores: Record<string, string>,
): string {
  const campos = camposDaEstrategia(estrategia);
  if (estrategia.tipo === "campo") return valores[campos[0]] ?? "";
  return campos.map((campo) => valores[campo] ?? "").join("|");
}
